import script from "./TagInputVue.vue?vue&type=script&setup=true&lang=js"
export * from "./TagInputVue.vue?vue&type=script&setup=true&lang=js"

import "./TagInputVue.vue?vue&type=style&index=0&id=540aca72&lang=scss&scoped=true"

import exportComponent from "../../fin_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540aca72"]])

export default __exports__